const SERVICE_TYPES = {
  // cpl auth api clients
  CPLAuthAuthenticationClient: Symbol.for("CPLAuthAuthenticationClient"),
  CPLAuthCompaniesClient: Symbol.for("CPLAuthCompaniesClient"),
  CPLAuthClientPortalUsersClient: Symbol.for("CPLAuthClientPortalUsersClient"),
  CPLSettingsClient: Symbol.for("CPLSettingsClient"),
  CPLAuthCompanyBrandingClient: Symbol.for("CPLAuthCompanyBrandingClient"),
  CPLAuthMaintenanceClient: Symbol.for("CPLAuthMaintenanceClient"),
  CPLAuthClientPortalCookiesClient: Symbol.for("CPLAuthClientPortalCookiesClient"),
  CPLAuthImpersonationClient: Symbol.for("CPLAuthImpersonationClient"),

  // cpl api clients
  CPLClientPortalClientsClient: Symbol.for("CPLClientPortalClientsClient"),
  CPLClientPortalAccountsClient: Symbol.for("CPLClientPortalAccountsClient"),
  CPLClientPortalJobsClient: Symbol.for("CPLClientPortalJobsClient"),
  CPLClientPortalCommentsClient: Symbol.for("CPLClientPortalCommentsClient"),
  CPLTextEditorImageUploadClient: Symbol.for("CPLTextEditorImageUploadClient"),
  CPLClientPortalCasesClient: Symbol.for("CPLClientPortalCasesClient"),
  CPLClientPortalPropertiesClient: Symbol.for("CPLClientPortalPropertiesClient"),
  CPLClientPortalCaseTypesClient: Symbol.for("CPLClientPortalCaseTypesClient"),
  CPLClientPortalProposedWorksClient: Symbol.for("CPLClientPortalProposedWorksClient"),
  //CPLDevelopmentsClient: Symbol.for("CPLDevelopmentsClient"),
  CPLClientPortalDocumentsClient: Symbol.for("CPLClientPortalDocumentsClient"),
  CPLClientPortalCreditControlClient: Symbol.for("CPLClientPortalCreditControlClient"),
  CPLClientPortalMeetingsClient: Symbol.for("CPLClientPortalMeetingsClient"),
  CPLClientPortalMeetingTypesClient: Symbol.for("CPLClientPortalMeetingTypesClient"),
  CPLClientPortalProposedWorkTypesClient: Symbol.for("CPLClientPortalProposedWorkTypesClient"),
  CPLClientPortalGlobalSearchClient: Symbol.for("CPLClientPortalGlobalSearchClient"),
  CPLClientPortalNewsClient: Symbol.for("CPLClientPortalNewsClient"),
  CPLCLientPortalPaymentsClient: Symbol.for("CPLCLientPortalPaymentsClient"),
  CPLClientPortalAccountContactDetailsClient: Symbol.for("CPLClientPortalAccountContactDetailsClient"),
  CPLClientPortalDevelopmentsClient: Symbol.for("CPLClientPortalDevelopmentsClient"),
  CPLClientPortalWebNarrativesClient: Symbol.for("CPLClientPortalWebNarrativesClient"),
  CPLClientPortalSettingsClient: Symbol.for("CPLClientPortalSettingsClient"),
  CPLClientPortalBudgetsClient: Symbol.for("CPLClientPortalBudgetsClient"),

  // services
  CompaniesService: Symbol.for("CompaniesService"),
  SessionService: Symbol.for("SessionService"),
  AuthenticationService: Symbol.for("AuthenticationService"),
  ClientPortalUsersService: Symbol.for("ClientPortalUsersService"),
  ClientPortalAccountsService: Symbol.for("ClientPortalAccountsService"),
  SettingsService: Symbol.for("SettingsService"),
  CompanyBrandingService: Symbol.for("CompanyBrandingService"),
  ClientsService: Symbol.for("ClientsService"),
  ClientPortalJobsService: Symbol.for("ClientPortalJobsService"),
  ClientPortalCommentsService: Symbol.for("ClientPortalCommentsService"),
  TextEditorImageUploadService: Symbol.for("TextEditorImageUploadService"),
  ClientPortalCasesService: Symbol.for("ClientPortalCasesService"),
  ClientPortalPropertiesService: Symbol.for("ClientPortalPropertiesService"),
  ClientPortalCaseTypesService: Symbol.for("ClientPortalCaseTypesService"),
  ClientPortalProposedWorksService: Symbol.for("ClientPortalProposedWorksService"),
  ClientPortalDocumentsService: Symbol.for("ClientPortalDocumentsService"),
  CPLClientPortalCreditControlService: Symbol.for("CPLClientPortalCreditControlService"),
  CPLClientPortalMeetingsService: Symbol.for("CPLClientPortalMeetingsService"),
  CPLClientPortalMeetingTypesService: Symbol.for("CPLClientPortalMeetingTypesService"),
  CPLClientPortalProposedWorkTypesService: Symbol.for("CPLClientPortalProposedWorkTypesService"),
  ClientPortalGlobalSearchService: Symbol.for("CPLClientPortalGlobalSearchService"),
  CPLClientPortalNewsService: Symbol.for("CPLClientPortalNewsService"),
  ClientPortalPaymentsService: Symbol.for("ClientPortalPaymentsService"),
  ClientPortalAccountContactDetailsService: Symbol.for("ClientPortalAccountContactDetailsService"),
  ClientPortalDevelopmentsService: Symbol.for("ClientPortalDevelopmentsService"),
  MaintenanceService: Symbol.for("MaintenanceService"),
  ClientPortalWebNarrativesService: Symbol.for("ClientPortalWebNarrativesService"),
  ClientPortalCPLSettingsService: Symbol.for("ClientPortalCPLSettingsService"),
  ClientPortalCookieService: Symbol.for("ClientPortalCookieService"),
  ClientPortalBudgetsService: Symbol.for("ClientPortalBudgetsService"),
};

export { SERVICE_TYPES };
